import * as React from 'react';
import Utils from '../../utils';
import { LoaderVariants } from './styles';
import { Progress } from '../../containers/DownloadManager/reducer';

const Translate = require('react-redux-i18n').Translate;

export enum LoaderStepName {
	Creating = 'Creating',
	Downloading = 'Downloading',
	DownloadingDependencies = 'DownloadingDependencies',
	DownloadingAll = 'DownloadingAll',
	LoggingIn = 'LoggingIn'
}

export interface LoggingInStep {
	step: LoaderStepName.LoggingIn;
}

export interface CreatingStep {
	step: LoaderStepName.Creating;
}

export interface DownloadingStep {
	step: LoaderStepName.Downloading;
	progress?: Progress;
}

export interface DownloadingDependenciesStep {
	step: LoaderStepName.DownloadingDependencies;
	dependenciesDownloaded: number;
	dependenciesToDownload: number;
}

export interface DownloadingAllStep {
	step: LoaderStepName.DownloadingAll;
	itemsDownloaded: number;
	itemsToDownload: number;
}

export enum LoaderType {
	Button = 'Button',
	Overlay = 'Overlay',
	ListItem = 'ListItem',
}

export type LoaderStep = DownloadingStep | DownloadingDependenciesStep | DownloadingAllStep | CreatingStep | LoggingInStep;

export interface LoaderProps {
	loaderStep: LoaderStep;
	type: LoaderType;
	isDownloadInProgress?: boolean;
	isUpdating?: boolean;
}

const Loader = (props: LoaderProps) => {
	const { loaderStep, type, isDownloadInProgress, isUpdating } = props;
	const StyledLoader = LoaderVariants[type];

	if (type === LoaderType.ListItem) {
		if (loaderStep.step === LoaderStepName.Downloading) {
			const { progress } = loaderStep;
			let progressValue = '';
			if (progress && progress.loaded && progress.totalSize && !!+progress.totalSize) {
				const progressNumber = Math.floor(progress.loaded * 100 / progress.totalSize);
				progressValue = `${Math.min(100, progressNumber)}%`;
			}
			return (
				<StyledLoader step={loaderStep.step}>
					<Translate key="loading" value="messages.loading" />
					<div>
						{isDownloadInProgress && Utils.getSvgIcon('iconset_loading')}
						{progressValue}
					</div>
				</StyledLoader>
			);
		}

		if (loaderStep.step === LoaderStepName.DownloadingDependencies) {
			const { dependenciesDownloaded, dependenciesToDownload } = loaderStep;
			let message = '';

			if (isUpdating) {
				message = 'messages.updating_asset';
			} else if (dependenciesToDownload < 2) {
				message = 'messages.dependency_downloaded_out_of';
			} else {
				message = 'messages.dependencies_downloaded_out_of';
			}

			return (
				<StyledLoader step={loaderStep.step}>
					{isDownloadInProgress && Utils.getSvgIcon('iconset_loading')}
					<Translate
						value={message}
						dependenciesDownloaded={dependenciesDownloaded}
						dependenciesToDownload={dependenciesToDownload}
					/>
				</StyledLoader>
			);
		}
	}

	return (
		<StyledLoader step={loaderStep.step}>
			{Utils.getSvgIcon('iconset_loading')}
			{getLoadingMessage(loaderStep)}
		</StyledLoader>
	);
};

const getLoadingMessage = (loaderStep: LoaderStep) => {
	switch (loaderStep.step) {
		case LoaderStepName.Downloading:
			const { progress } = loaderStep;
			return [
				<Translate key="loading" value="messages.loading" />,
				progress && progress.loaded && progress.totalSize && !!+progress.totalSize && `${Math.floor(progress.loaded * 100 / progress.totalSize)}%`,
			];
		case LoaderStepName.DownloadingDependencies:
			const { dependenciesDownloaded, dependenciesToDownload } = loaderStep;
			return (
				<Translate
					value={dependenciesToDownload < 2 ? 'messages.dependency_downloaded_out_of' : 'messages.dependencies_downloaded_out_of'}
					dependenciesDownloaded={dependenciesDownloaded}
					dependenciesToDownload={dependenciesToDownload}
				/>
			);
		case LoaderStepName.DownloadingAll:
			const { itemsDownloaded, itemsToDownload } = loaderStep;
			return (
				<Translate
					value={itemsToDownload < 2 ? 'messages.item_downloaded_out_of' : 'messages.items_downloaded_out_of'}
					itemsDownloaded={itemsDownloaded}
					itemsToDownload={itemsToDownload}
				/>
			);
		case LoaderStepName.Creating:
			return <Translate value="messages.create_demo_account" />;
		case LoaderStepName.LoggingIn:
			return <Translate value="messages.logging_in" />;
		default:
			return;
	}
};

export default Loader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/index.tsx